/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-danger */
import { useEffect, useRef } from "react";
import parse from "html-react-parser";
import { wireTopAirlineCarousel } from "../../utils/CommonUtils";

export default function FlightRouteDT(props) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (language && language === "ar") document.body.classList.add("isArabic");
  });
  const {
    language,
    initial_js: initialJS = "",
    main_div: mainDiv,
    top_overlay,
    ccde,
    isGoibibo = false,
  } = props?.data || {};

  useEffect(() => {
    wireTopAirlineCarousel(containerRef.current);
  }, [mainDiv]);

  const googleTagId = isGoibibo ? "GTM-5VDCXLQ" : "GTM-NWV3K7C";
  const googletTagString = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${googleTagId}');
`;

  return (
    <>
      {initialJS && initialJS !== "" ? parse(initialJS) : null}
      <div ref={containerRef} dangerouslySetInnerHTML={{ __html: mainDiv }} />
      <div dangerouslySetInnerHTML={{ __html: top_overlay }} />
      {ccde && (ccde === "" || ccde === "in" || ccde === "IN") ? (
        <script dangerouslySetInnerHTML={{ __html: googletTagString }} />
      ) : null}
    </>
  );
}
